import Color from 'color';
import styled from 'styled-components';

import DangerSvg from '../../../../assets/icons/secondary/Danger.svg';
import {ms} from '../../../../styles/normalizeSize';
import {getColor, square} from '../../../../styles/utils';
import {View} from '../../../../uikit/View';
import {NameContainer} from './styles.common';

export const DangerIcon = styled(DangerSvg).attrs(p => ({
  fill: getColor('icon.white')(p),
}))`
  ${square(16)}
`;

export const UnblockAudioWrapper = styled(View)`
  position: absolute;
  left: 0;
  right: 0;
  top: ${ms(10)};
  padding: 0 ${ms(10)};
`;

export const UnblockAudioContainer = styled(NameContainer)`
  background-color: ${p =>
    Color(getColor('icon.red')(p)).alpha(0.6).toString()};
`;

export const VideoDisableWarningWrapper = styled(View)`
  position: absolute;
  right: 0;
  top: ${ms(10)};
  padding: 0 ${ms(10)};
`;

export const VideoDisableWarningContainer = styled(NameContainer)`
  background-color: ${p =>
    Color(getColor('icon.red')(p)).alpha(0.6).toString()};
`;
